module.exports = __webpack_public_path__ + "a809ec1f9ffd078c3f3a14c051fee810.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/cos/0C00000PMM.png
// module id = 1628
// module chunks = 0